import React, { useEffect, useState } from 'react'
import Fotter from '../Components/Fotter'
import { FormProvider, useForm } from 'react-hook-form'
import UpdatePassword from '../Components/UpdatePassword'
import UpdatePasswordAtFirstConnexion from '../Components/UpdatePasswordAtFirstConnexion'
import axios from 'axios'
import { useSignIn } from 'react-auth-kit'
import env from 'react-dotenv'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { Crypter } from '../Functions/Security/Crypter'
import Hash from '../Functions/Security/Hash'
import datas from "../Assets/data.json"
import otp_image from '../Assets/20602807_6333055 1.svg'
import OTPInput from 'react-otp-input'
import { Button, Spin, useAlert } from '../Components/ui'
import otpImage from "../Assets/EBCallLogo.png"

interface Props { }

function OTP(props: Props) {
    const { } = props
    const navigat = useNavigate()
    const signIn = useSignIn()
    const alert = useAlert()

    const { register, handleSubmit, setValue, reset } = useForm()
    const [fichier, setFicher] = useState<File>()
    const [isOk, setIsOk] = useState<boolean>(false)
    const [loading, setLoading] = useState<boolean>(false)
    const [mustUpPass, setmustUpPass] = useState<boolean>(false)

    const [user, setUser] = useState<any>(null)
    const [mail, setMail] = useState<any>("")
    const [image, setImage] = useState<any>(null)
    const [codeU, setCodeU] = useState<any>(null)
    const [searchParams, setSearchParams] = useSearchParams();

    const [otp, setOtp] = useState('');

    const methods = useForm();


    // const onSubmit = async (data: any) => {
    //     try {
    //         let user = JSON.parse(Crypter.decrypt(localStorage.getItem(datas.user) + ""))
    //         if (signIn(
    //             {
    //                 token: user.token,
    //                 expiresIn: 3600,  //Provisoir
    //                 tokenType: "Bearer",
    //                 authState: { "CodeU": user.CodeU, "Name": user.Name + " " + user.Prenom, "RoleId": user.RoleId, "CodeS": user.CodeS, "CodeFiliale": user.CodeFiliale, "Image": user.Image, "Group": user.RoleId, "CodeAbonne": user.CodeAbonne },
    //                 //refreshToken: res.data.refreshToken,                    // Only if you are using refreshToken feature
    //                 //refreshTokenExpireIn: res.data.refreshTokenExpireIn     // Only if you are using refreshToken feature
    //             }
    //         )) {
    //             // Redirect or do-something
    //             navigat("/")
    //         } else {
    //             Swal.fire({
    //                 title: "Une érreur s'est produit",
    //                 icon: 'error'
    //             })
    //         }

    //     } catch (error) {
    //         Swal.fire({
    //             title: "Une érreur s'est produit",
    //             icon: 'error'
    //         })
    //         navigat("/")
    //     }

    //     // data.Pass = Hash(data.Pass)

    //     // setLoading(true)
    //     // let config = {
    //     //     method: 'post',
    //     //     maxBodyLength: Infinity,
    //     //     url: env.API_BASE_URL + datas.API_LINKs.Connexion,
    //     //     headers: {
    //     //         'Content-Type': 'application/json'
    //     //     },
    //     //     data: Crypter.encrypt(JSON.stringify(data))
    //     // };
    //     // axios.request(config)
    //     //     .then((response: any) => {
    //     //         setLoading(false)
    //     //         let res = JSON.parse(Crypter.decrypt(response.data)).Value
    //     //         if (res.StatutCode == 200) {
    //     //             let user = res.Result[0][0];
    //     //             localStorage.setItem(datas.Habilitations, Crypter.encrypt(JSON.stringify(res.Result[1])))
    //     //             if (signIn(
    //     //                 {
    //     //                     token: user.token,
    //     //                     expiresIn: 3600,  //Provisoir
    //     //                     tokenType: "Bearer",
    //     //                     authState: { "CodeU": user.CodeU, "Name": user.Name + " " + user.Prenom, "RoleId": user.RoleId, "CodeS": user.CodeS, "CodeFiliale": user.CodeFiliale, "Image": user.Image, "Group": user.RoleId, "CodeAbonne": user.CodeAbonne },
    //     //                     //refreshToken: res.data.refreshToken,                    // Only if you are using refreshToken feature
    //     //                     //refreshTokenExpireIn: res.data.refreshTokenExpireIn     // Only if you are using refreshToken feature
    //     //                 }
    //     //             )) {
    //     //                 // Redirect or do-something
    //     //                 navigat("/")
    //     //             } else {
    //     //                 Swal.fire({
    //     //                     title: "Une érreur s'est produit",
    //     //                     icon: 'error'
    //     //                 })
    //     //             }
    //     //             reset()

    //     //         } else {
    //     //             Swal.fire({
    //     //                 title: res.Message,
    //     //                 icon: 'warning'
    //     //             })
    //     //         }
    //     //     })
    //     //     .catch((error) => {
    //     //         setLoading(false)
    //     //         Swal.fire({
    //     //             title: error.message,
    //     //             icon: 'error'
    //     //         })
    //     //     });
    // }
    
    const onSubmit_auto = (otp_param : string, codeU_param: string, eMail_param: string) => {
        setLoading(true)
        var data = { "codeU": codeU_param, "Email": eMail_param, OTP: otp_param }
        let config = {
            method: 'put',
            maxBodyLength: Infinity,
            url: env.API_BASE_URL + datas.API_LINKs.VerfifOTP,
            headers: {
                'Content-Type': 'application/json'
            },
            data: Crypter.encrypt(JSON.stringify(data))
        };

        axios.request(config)
            .then((response) => {
                setLoading(false)
                let res = JSON.parse(Crypter.decrypt(response.data)).Value
                if (res.StatutCode == 200) {
                    
                    setUser(res.Result.Table1[0])

                    reset()
                    localStorage.setItem("verif_otp", "1")
                    // localStorage.setItem(datas.user, Crypter.encrypt(JSON.stringify(res.Result.Table1[0])))
                    // alert(JSON.stringify(res.Result.Table1[0]))
                    setmustUpPass(true)
                    navigat("/OTP_Verification")
                } else {
                    alert.warning(res.Message)
                }
            })
            .catch((error) => {
                setLoading(false)
                alert.error(error.message)
            });
    }
    const onSubmit = () => {
        // alert(mail+" - "+codeU+" - "+otp)
        setLoading(true)
        var data = { "codeU": codeU, "Email": mail, OTP: otp }
        let config = {
            method: 'put',
            maxBodyLength: Infinity,
            url: env.API_BASE_URL + datas.API_LINKs.VerfifOTP,
            headers: {
                'Content-Type': 'application/json'
            },
            data: Crypter.encrypt(JSON.stringify(data))
        };

        axios.request(config)
            .then((response) => {
                setLoading(false)
                let res = JSON.parse(Crypter.decrypt(response.data)).Value
                if (res.StatutCode == 200) {
                    setmustUpPass(true)

                    reset()

                    localStorage.setItem("verif_otp", "1")
                    localStorage.setItem(datas.user, Crypter.encrypt(JSON.stringify(res.Result)))
                    navigat("/OTP_Verification")
                } else {
                    alert.warning(res.Message)
                }
            })
            .catch((error) => {
                setLoading(false)
                alert.error(error.message)
            });
    }
    useEffect(() => {
        try {

            try {
                var otp_param: string = ""
                var codeU_param: string = ""
                var eMail_param: string = ""
                otp_param = Crypter.decrypt(searchParams.get(datas.otp_param)?.replaceAll(" ", "+") as string);
                codeU_param = Crypter.decrypt(searchParams.get(datas.codeU_param)?.replaceAll(" ", "+") as string);
                eMail_param = Crypter.decrypt(searchParams.get(datas.eMail_param)?.replaceAll(" ", "+") as string);
                setOtp(otp_param)
                setCodeU(codeU_param)
                setMail(eMail_param)
                if (otp_param == "" || codeU_param == "" || eMail_param == "") {
                    navigat("/Login")
                } else {
                    onSubmit_auto(otp_param, codeU_param, eMail_param)
                }
            } catch (error : any) {
                // alert(error.message)

                try {
                    let verif_otp = localStorage.getItem("verif_otp")
                    if (verif_otp != "1") {
                        // navigat("/Login")
                        window.location.replace("/Login")
                    }
                    else {

                        try {
                            let email = JSON.parse(Crypter.decrypt(localStorage.getItem(datas.user) + ""))?.Table[0].Message as any
                            let m = (email + "").split(" ")[(email + "").split(" ").length - 1]
                            setMail(m)
                            setImage(JSON.parse(Crypter.decrypt(localStorage.getItem(datas.user) + ""))?.Table1[0].Image as any)
                            setCodeU(Crypter.decrypt(localStorage.getItem("CodeU") + ""))
                            setUser(JSON.parse(Crypter.decrypt(localStorage.getItem(datas.user) + ""))?.Table1[0] as any)
                        } catch (error) {

                        }
                    }
                } catch (error) {
                    navigat("/Login")
                }
            }


        } catch (error) {

            navigat("/Login")
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])



    return (
        <div>
            <div className='bool1'>.</div>
            <div className='bool2'>.</div>
            <div className='bool3'>.</div>
            <FormProvider {...methods}>
                <div className="form_gl flex w-3/5">
                    <img width={"60%"} src={otp_image} alt="" />
                    <div className='form w-full'>
                        <center style={{ marginTop: "-70px", borderRadius: "100px" }}>
                            <img src={otpImage} style={{ border: "1px rgba(25, 7, 143, .5) solid", borderRadius: "100%", backgroundColor: "rgba(255, 255, 255, .5)" }} width={100} />
                            <br />
                            {image ? <img width={100} height={100} src={image} style={{ borderRadius: "10px" }} /> : ""}
                        </center><br />
                        <Spin spinning={loading}>
                            <form onSubmit={handleSubmit(onSubmit)}>
                                <div className='round0'>{/*className='round0'*/}
                                    <center>
                                        <h3 className="text-base font-bold text-[var(--eb-text)]"><marker style={{ backgroundColor: "darkblue", borderRadius: "10%", color: "rgba(255, 255, 255, 1)", padding: ".5%" }}>2F</marker> AUTHENTIFICATION</h3>
                                        <p className="text-sm text-[var(--eb-text-muted)]">Veillez renseigner votre code OTP </p>
                                        <center style={{ fontSize: "13px", color: "gray" }}>{mail}</center><br />
                                    </center>
                                    <div className='ressource'>
                                        <OTPInput
                                            value={otp}
                                            onChange={setOtp}
                                            inputType='password'
                                            numInputs={6}
                                            renderSeparator={<span style={{ width: '5px' }}></span>}
                                            renderInput={(props) => <input required {...props} className='input_otp' style={{ width: "50px", height: "40px", borderRadius: "10px" }} />}
                                        />
                                        <br />
                                        <div className="flex gap-1">
                                            <Button className="w-full" variant='primary' type='submit'>Valider</Button>
                                        </div><br />
                                        <div className="flex">
                                            <Button variant="ghost">OTP non reçu? Réenvoyez</Button>
                                        </div>
                                    </div>
                                </div>

                            </form>
                        </Spin>
                    </div>
                </div>
                {(mustUpPass && (user != null)) ? <UpdatePasswordAtFirstConnexion reccord={user} /> : ''}
            </FormProvider>
            <Fotter />
            <div className='bool4'>.</div>
            <div className='bool5'>.</div>
        </div>
    )
}

export default OTP
